export default "__VITE_ASSET__65b2c90e__"